import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

// Custom hook for handling file-related operations
export const useFileHandler = () => {
  const { t } = useTranslation();
  const [file, setFile] = useState(null);
  const [fileExtension, setFileExtension] = useState('');

  const handleFileInputChange = (e) => {
    const selectedFile = e.target.files[0];
    const inputEP_IDFileExtension = e.target.files[0]?.name?.split('.').pop();
    setFileExtension(inputEP_IDFileExtension);
    const fileSize = selectedFile.size;
    if (
      (inputEP_IDFileExtension == 'jpg' ||
        inputEP_IDFileExtension == 'png' ||
        inputEP_IDFileExtension == 'jpeg' ||
        inputEP_IDFileExtension == 'pdf') &&
      fileSize <= 2097152
    ) {
      setFile(selectedFile);
      toast.success(t('File uploaded successfully.'));
    } else {
      setFile('');
      toast.error(
        t('Uploaded File must contain these formats [jpg, png, jpeg, pdf] and must not be greater than 2 MBs'),
      );
    }
  };

  const clearFile = () => {
    setFile(null);
  };

  const getFileBase64 = async () => {
    return new Promise((resolve, reject) => {
      if (!file) {
        reject(new Error('No file provided'));
        return;
      }

      const reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(file);
    });
  };

  return { file, fileExtension, handleFileInputChange, clearFile, getFileBase64 };
};
